var _style, _g, _path, _g2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgLogoWhite(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_1",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    x: "0px",
    y: "0px",
    viewBox: "0 0 319 70",
    style: {
      enableBackground: "new 0 0 319 70"
    },
    xmlSpace: "preserve",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _style || (_style = /*#__PURE__*/React.createElement("style", {
    type: "text/css"
  }, "\n\t.st0{opacity:0.7;}\n\t.st1{fill:#FFFFFF;}\n")), _g || (_g = /*#__PURE__*/React.createElement("g", {
    className: "st0"
  }, /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M49.9,27.9l-4.2,4.5L41.1,28l-4.3,4.5L32,28.1l8.6-9l-9.7-9.1l-21.7,23l9.7,9.1l4.1-4.3l4.8,4.5L19.3,51 l4.6,4.3l0,0l-8.7-8.2l-0.8-0.7l-4.6-4.3L0,32.7L26,5.3l-4.6-4.3L49.3,0L49.9,27.9z"
  }))), _path || (_path = /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M33.9,64.7l4.6,4.3L10.6,70L9.9,42.1l5.3,5l-0.8-0.7l4.2-4.3l0.1-0.1l4.1-4.3l4.8,4.5L19.3,51l4.6,4.3l5.1,4.8 l21.7-23l-5.1-4.8L41.1,28l4.3-4.5l4.6,4.3l9.9,9.4L33.9,64.7z"
  })), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M98.5,21v19.7C98.5,48,94.1,54,85.2,54c-9,0-13.4-6.1-13.4-13.3V21h7.8v19.6c0,3.6,1.8,6,5.6,6 c3.7,0,5.5-2.4,5.5-6V21H98.5z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M126.9,37.8v15.6h-7.8V39.3c0-2.7-1.8-4.2-4.2-4.2s-4.2,1.7-4.2,3.9v14.4h-7.8V28.8h7.3v2 c1.7-1.5,4.1-2.6,7.1-2.6C123.1,28.2,126.9,32.2,126.9,37.8z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M130.2,20.8c0-2.8,2.1-4.8,4.9-4.8c2.8,0,4.9,2,4.9,4.8s-2.1,4.8-4.9,4.8C132.3,25.5,130.2,23.6,130.2,20.8z  M131.2,28.8h7.8v24.6h-7.8V28.8z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M145.8,44v-8.5h-4.1v-6.6h2c1.7,0,2.6-0.9,2.6-2.8v-3.8h7.6v6.5h5.6v6.6h-5.9V43c0,2.4,1.3,3.6,3.5,3.6h2.6 v6.8h-4.2C149,53.4,145.8,49.6,145.8,44z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M174.5,47.7c2.8,0,4.1-0.9,5.1-2.6l5.8,3.9c-2,2.6-5,5-11.1,5c-8.1,0-13.2-5.5-13.2-12.9 c0-7.1,5.7-12.9,12.8-12.9c8,0,12.8,6.3,12.8,12.4c0,1.2-0.1,2.1-0.2,2.8h-17.8C169.4,46.2,171.6,47.7,174.5,47.7z M179.4,38.6 c-0.7-2.8-2.5-4.5-5.4-4.5s-4.9,1.5-5.5,4.5H179.4z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M215.4,19.3v34.1h-7.2v-2.1c-1.8,1.7-4.2,2.7-7.1,2.7c-7.1,0-12.3-5.5-12.3-12.9c0-7.4,4.9-12.9,12.1-12.9 c2.7,0,4.9,0.8,6.7,2.3V19.3H215.4z M208,41.2c0-3.6-2.3-6.1-5.7-6.1c-3.3,0-5.6,2.6-5.6,6.1c0,3.5,2.3,6,5.6,6 C205.7,47.2,208,44.7,208,41.2z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M251.3,46.5v6.9h-22.2V21h7.8v25.5H251.3z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M253.1,20.8c0-2.8,2.1-4.8,4.9-4.8c2.8,0,4.9,2,4.9,4.8s-2.1,4.8-4.9,4.8C255.2,25.5,253.1,23.6,253.1,20.8z  M254.1,28.8h7.8v24.6h-7.8V28.8z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M290.3,37.8v15.6h-7.8V39.3c0-2.7-1.8-4.2-4.2-4.2c-2.3,0-4.2,1.7-4.2,3.9v14.4h-7.8V28.8h7.3v2 c1.7-1.5,4.1-2.6,7.1-2.6C286.5,28.2,290.3,32.2,290.3,37.8z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M310.2,53.4l-7.8-10.8v10.8h-7.8V19.3h7.8v18.8l7.5-9.3h8.6l-9.1,11.3l9.2,13.2H310.2z"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgLogoWhite);
export default __webpack_public_path__ + "static/media/logo-white.fb014d80f84b71f7bb241f07a5bb2471.svg";
export { ForwardRef as ReactComponent };